export default __webpack_public_path__ + "static/sOliverCase-RegularWeb-4ebccce1faabaef15a37bda35b188810.woff2";